import React, { useEffect, useState } from 'react';
import { Pagination, Spinner } from '../../components/common';
import Header from '../../components/common/global-top-bar';
import SwitchBar from '../../components/switch-bar';
import { Headeroptions, PeerHeaderoptions } from './listener-constants';

import Modal from '../../components/common/modal';
import Searchbar from '../../components/common/searchbar';
import ReactTooltip from 'react-tooltip';
import moment from 'moment-timezone';
import { crisisIcon, log } from '../../assets/images';
import { paramsToObjects } from '../../components/common/create-params';
import HeadBack from './redirect';
import { connectionOutcomeText, convertToHoursMinuteSeconds, generateResources } from '../../components/connections';
import {
  useConnectionsCount,
  useConnections,
  useEvents,
  Count,
  TopicTag,
  Connection,
  Event,
} from '../../hooks/useConnections';

const Connections: React.FC = (): JSX.Element => {
  const timeZone = moment.tz(moment.tz.guess()).zoneName();
  const params = paramsToObjects() || {};
  const { listenerName, listenerRoleId, listenerType } = params;
  const [enableCallPopUp, setEnableCallPopUp] = useState(false);
  const [filters, setFilters] = useState<{
    page: number;
    limit: number;
    search?: string;
  }>({
    page: 1,
    limit: 25,
  });
  const { page, limit, search } = filters;
  const [callId, setCallId] = useState<number | undefined>(undefined);
  const [requestId, setRequestId] = useState<number | undefined>(undefined);
  const { data: count, refetch: refetchCount } = useConnectionsCount({ search, listenerRoleId });
  const {
    data: connections,
    isFetching,
    refetch: refetchConnections,
  } = useConnections({ page, limit, search, listenerRoleId });
  const { data: callLog } = useEvents(callId, requestId);

  useEffect(() => {
    refetchConnections();
    refetchCount();
  }, [filters, refetchConnections, refetchCount]);

  return (
    <div>
      <Header heading={<HeadBack listenerName={listenerName || ''} listenerId={Number(listenerRoleId)} />} />
      <SwitchBar heading={listenerType === 'peer' ? PeerHeaderoptions : Headeroptions} position={3} forwardParams />
      <Filters count={count} setFilters={setFilters} />
      {isFetching && <Spinner alignmentClass={'left-64 top-40 fixed z-100 inset-0 overflow-y-auto'} />}

      <div className="max-window-height-connections overflow-y-auto px-7">
        <div className="table-overflow">
          <table className="table-row-format relative w-screen table-fixed border-collapse overflow-x-scroll">
            <thead className="h-full bg-white">
              <tr className="w-full px-7 text-left">
                <th className="sticky top-0 mb-4 h-full w-8 bg-white py-2"></th>
                <th className="sticky top-0 mb-4 h-full w-44 bg-white py-2">
                  <p className="px-2">Member</p>
                </th>
                <th className="sticky top-0 mb-4 h-full w-52 bg-white text-left">Date/Time</th>

                <th className="sticky top-0 mb-4 h-full w-24 bg-white">Length</th>
                <th className="sticky top-0 mb-4 h-full w-24 bg-white">Type</th>
                <th className="sticky top-0 mb-4 h-full w-44 bg-white">Topic</th>
                <th className="sticky top-0 mb-4 h-full w-56 bg-white">Topics Discussed</th>
                <th className="sticky top-0 mb-4 h-full w-40 bg-white">
                  <p className="pl-2">Outcome</p>
                </th>
                <th className="sticky top-0 mb-4 h-full w-40 bg-white">
                  <p className="pl-2">Result</p>
                </th>
                <th className="sticky top-0 mb-4 h-full w-36 bg-white">Impact Score</th>
                <th className="sticky top-0 mb-4 h-full w-40 bg-white">Call Reported?</th>
                <th className="sticky top-0 mb-4 h-full w-48 bg-white">Mood (Before/After)</th>
                <th className="sticky top-0 mb-4 h-full w-24 bg-white">Resources</th>
                <th className="sticky top-0 z-50 mb-4 h-full w-20 bg-white px-1 py-2 text-right">
                  <p className="px-3">Log</p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="h-2"></tr>
              {connections &&
                connections.length > 0 &&
                connections?.map((connection: Connection) => {
                  const callDate = connection?.scheduled_at
                    ? connection.scheduled_at
                    : connection?.created_at && connection?.created_at;
                  const startDate = callDate ? moment(callDate).local().format('MMM Do YYYY') : '-';
                  const time = callDate ? moment(callDate).format('HH:mm') : '-';

                  return (
                    <tr className="text-gray-dark h-12 space-y-6 rounded border-4 border-y border-white bg-gray-200 text-left">
                      <td>{connection?.crisis_elevation_id && <img src={crisisIcon} alt="crisis"></img>}</td>
                      <td className="pl-2">{`${connection?.request?.caller_role.user.first_name} (${connection?.request?.caller_role?.user.id})`}</td>
                      <td className=" ">
                        {startDate} / {time} {timeZone}
                      </td>
                      <td className=" ">
                        {connection?.request?.call
                          ? convertToHoursMinuteSeconds(connection?.request?.call.logged_duration)
                          : `--`}
                      </td>
                      <td className="py-1">
                        <button
                          className={
                            'h-full w-full cursor-auto rounded-full px-2 py-2 text-center text-xs text-white' +
                            (connection.scheduled_at ? ' bg-magenta' : ' bg-violet')
                          }
                        >
                          {connection.scheduled_at ? ' Scheduled ' : ' Now '}
                        </button>
                      </td>
                      <td className="px-2 py-1">
                        <button
                          className={
                            'bg-blue-gradient-1 h-full w-full cursor-auto rounded-md px-2 py-2 text-center text-xs text-white'
                          }
                        >
                          {connection.request.topic ? connection.request.topic.name : ' No Topic '}
                        </button>
                      </td>
                      <td className="px-2 py-1">
                        <TopicsDiscussed topics={connection.request.call?.postcall_metadata?.topic_tags} />
                      </td>
                      <td className="px-2 py-1">
                        <button
                          className={
                            'h-full w-full cursor-auto rounded-full px-2 py-2 text-center text-xs text-white ' +
                            (connection.outcome === 'Call Scheduled'
                              ? 'bg-blue-gradient-1'
                              : connection.outcome === 'Call'
                                ? 'bg-green'
                                : connection.outcome === 'Short Call'
                                  ? ' bg-magenta'
                                  : connection.outcome === 'Passed'
                                    ? ' bg-orange'
                                    : connection.outcome === 'Missed'
                                      ? ' bg-red'
                                      : connection.outcome === 'Pending Response'
                                        ? ' '
                                        : connection.outcome === 'Cancelled'
                                          ? ' bg-red'
                                          : connection.outcome === 'Rescheduled'
                                            ? ' bg-violet'
                                            : ' bg-black')
                          }
                        >
                          {connection.outcome ? connectionOutcomeText(connection.outcome, connection.expired) : '-'}
                        </button>
                      </td>
                      <td className="px-2 py-1">{connection.result ? connection.result : '-'}</td>
                      <td
                        className={
                          'h-full w-full cursor-auto rounded-md px-2 py-2 text-center text-xs font-bold text-black'
                        }
                      >
                        {connection.request?.call?.impact_score ? connection.request.call.impact_score.toFixed(2) : '-'}
                      </td>
                      <td className=" ">No</td>
                      <td className=" ">
                        {connection.request.call?.postcall_metadata ? (
                          <>
                            <span className="text-red font-bold">
                              {connection.request.call?.postcall_metadata?.begin_call_mood?.toFixed(2) || 0.0}
                            </span>
                            <span>{' / '}</span>
                            <span className="text-green font-bold">
                              {connection.request.call?.postcall_metadata?.end_call_mood?.toFixed(2) || 0.0}
                            </span>{' '}
                          </>
                        ) : (
                          '--'
                        )}
                      </td>
                      <td className=" ">
                        {connection.request.call?.postcall_metadata?.resources?.length > 0 ? (
                          <ToolTip
                            text="view"
                            list={generateResources(connection.request.call?.postcall_metadata?.resources)}
                          />
                        ) : (
                          '--'
                        )}
                      </td>
                      <td className=" ">
                        <div className="flex items-center justify-end px-2">
                          <button
                            className="blue-primary h-full rotate-180 transform rounded-full"
                            onClick={() => {
                              connection?.request?.call_id
                                ? setCallId(connection?.request?.call_id)
                                : setRequestId(connection.request?.id);
                              setEnableCallPopUp(true);
                            }}
                          >
                            <img className="h-8 w-full" src={log} alt="call details"></img>
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
        <Modal
          isModel={enableCallPopUp}
          InnerComponent={
            <div className="z-100 fixed inset-0 flex items-center justify-center overflow-x-hidden outline-none focus:outline-none">
              <div className="min-w-3xl max-h-162.5 relative mx-auto my-6 w-auto max-w-5xl overflow-y-auto">
                <div className="relative flex w-full flex-col rounded-lg border-0 bg-white shadow-lg outline-none focus:outline-none">
                  <div className="flex items-start justify-between">
                    <div className="blue-primary px-10 pt-10 text-2xl">Call Details:</div>
                    <div className="flex items-center justify-center px-10 pt-10">
                      <button
                        className="bg-gray-light rounded-full px-7 py-2 text-center text-sm text-white"
                        type="button"
                        onClick={() => {
                          setEnableCallPopUp(false);
                          setCallId(undefined);
                          setRequestId(undefined);
                        }}
                      >
                        CLOSE
                      </button>
                    </div>
                  </div>
                  <table className="table-row-format relative mx-10 my-2 table-fixed border-collapse">
                    <thead className="h-full bg-white">
                      <tr className="w-full px-7 text-left">
                        <th className="text-gray-dark sticky top-0 mb-4 h-full w-6/12 bg-white px-2 py-2 text-base font-normal">
                          TimeStamp
                        </th>
                        <th className="text-gray-dark sticky top-0 mb-4 h-full w-6/12 bg-white px-2 py-2 text-base font-normal">
                          Event Category
                        </th>
                        <th className="text-gray-dark sticky top-0 mb-4 h-full w-6/12 bg-white px-2 py-2 text-base font-normal">
                          Event name
                        </th>
                        <th className="text-gray-dark sticky top-0 mb-4 h-full w-6/12 bg-white px-2 py-2 text-base font-normal">
                          Message
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {callLog && callLog.length > 0 ? (
                        callLog?.map((event: Event) => (
                          <tr
                            role="button"
                            className="text-gray-dark h-12 space-y-6 rounded border-4 border-y border-white text-left"
                          >
                            <td className="border-bottom w-1/4 py-1">
                              <div className="flex">
                                <p className="text-gray-dark text-bold pr-2 text-base font-bold">
                                  {moment(event.timestamp).format('ddd , MMMM Do YYYY, h:mm:ss a')}
                                </p>
                              </div>
                            </td>
                            <td className="border-bottom w-1/4 py-1">
                              <div className="flex">
                                <p className="text-gray-dark text-bold pr-2 text-base font-bold">
                                  {event.event_category}
                                </p>
                              </div>
                            </td>
                            <td className="border-bottom w-1/4 py-1">
                              <div className="flex">
                                <p className="text-gray-dark text-bold pr-2 text-base font-bold">{event.event_name}</p>
                              </div>
                            </td>
                            <td className="border-bottom w-1/4 py-1">
                              <div className="flex">
                                <p className="text-gray-dark text-bold pr-2 text-base font-bold">{event.message}</p>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr
                          role="button"
                          className="text-gray-dark h-12 space-y-6 rounded border-4 border-y border-white text-left"
                        >
                          <td className="border-bottom w-1/2 py-1">
                            <div className="flex">
                              <p className="text-gray-dark text-bold pr-2 text-base font-bold">No Data Available</p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          }
        />
      </div>
    </div>
  );
};

const Filters: React.FC<{
  count?: Count;
  clients?: Client[];
  setFilters: React.Dispatch<
    React.SetStateAction<{
      page: number;
      limit: number;
      search?: string;
    }>
  >;
}> = ({ count, clients, setFilters }) => {
  return (
    <div className="gray-border-line bg-gray-background-light flex h-10 w-full items-center justify-start border-b px-7">
      <div className="w-1/4">
        <div className="h-8 w-full">
          <Searchbar
            search={(data) => {
              setFilters((prev) => {
                return { ...prev, search: data ? data : undefined, page: 1 };
              });
            }}
          />
        </div>
      </div>
      <div className="w-1/3">
        <Pagination
          pageCount={Math.ceil((count?.count || 10) / 25)}
          key={count?.count}
          updatePageNumber={(data) => {
            setFilters((prev) => {
              return { ...prev, page: data + 1 };
            });
          }}
        />
      </div>
    </div>
  );
};

const TopicsDiscussed: React.FC<{ topics: TopicTag[] }> = ({ topics }): JSX.Element => {
  const generateTopics = (topics: TopicTag[]) => {
    return topics.map((topic: TopicTag) => topic.tag.name);
  };

  if (topics?.length === 1) {
    return <p>{topics[0].tag.name}</p>;
  } else if (topics?.length > 1) {
    return (
      <div>
        {topics[0].tag.name} and <ToolTip text={`${topics.length - 1} more`} list={generateTopics(topics.slice(1))} />
      </div>
    );
  }
  return <p>--</p>;
};

const ToolTip: React.FC<{ text: string; list: string[] }> = ({ text, list }): JSX.Element => {
  return (
    <>
      {' '}
      <a data-tip data-for={list[0]} className="cursor-pointer underline">
        {text}
      </a>
      <ReactTooltip id={list[0]} type="dark" place="bottom" effect="float">
        <ul>
          {list.map((tag: string) => (
            <li>{tag}</li>
          ))}
        </ul>
      </ReactTooltip>
    </>
  );
};

export default Connections;
